// "Who does it" in the one start dialog: the agents (each once), the
// subagents, the Team, the saved workflows (useWorkerOptions) and, for
// later only, a reminder. A worker the list no longer offers (a saved
// row's draft subagent, a workflow still loading) is kept at the top
// under its own name, so a saved row never shows an empty choice.

import { Dropdown, type DropdownOption } from "@/components/ui/Dropdown";
import { Field } from "@/features/settings/ui";
import { humanizeSlug } from "@/lib/format";

interface WhoFieldProps {
  value: string;
  /** useWorkerOptions' list. */
  workers: DropdownOption<string>[];
  /** Starting now: no reminder. */
  now: boolean;
  nameOf: (template: string) => string;
  error?: string;
  onChange: (worker: string) => void;
}

function labelOf(value: string, nameOf: (template: string) => string): string {
  if (value === "team") return "Team";
  if (value === "message") return "A reminder";
  if (value.startsWith("workflow:")) return humanizeSlug(value.slice("workflow:".length)) || value;
  return nameOf(value);
}

export function WhoField({ value, workers, now, nameOf, error, onChange }: WhoFieldProps) {
  const options: DropdownOption<string>[] = [...workers, ...(now ? [] : [{ value: "message", label: "A reminder", group: "Reminder" }])];
  if (value && !options.some((o) => o.value === value)) options.unshift({ value, label: labelOf(value, nameOf) });
  return (
    <Field label="Who does it" error={error}>
      {({ id }) => <Dropdown id={id} ariaLabel="Who does it" className="block w-full" matchTriggerWidth value={value} options={options} placeholder="Choose" onChange={onChange} />}
    </Field>
  );
}
